const components = {
    p({node, inline, className, children, ...props}) {
        const linkElements = node.children.filter(x => x.tagName === 'a');

        if (linkElements.length === node.children.length) {
            const linkElement = node.children.find(x => x.tagName === 'a');
            const hasHref = linkElement && linkElement.properties && linkElement.properties.href !== undefined;

            if (hasHref) {
                const extractedData = extractYoutubeId(linkElement.properties.href);

                if (extractedData.result) {
                    return <div className="markdown-embed">
                        <iframe
                            src={`https://www.youtube-nocookie.com/embed/${extractedData.id}?playlist=${extractedData.id}&loop=1&iv_load_policy=3&rel=0`}
                            title={extractedData.id}
                            allowFullScreen
                            allow="fullscreen; picture-in-picture; encrypted-media;">
                                Bitte aktiviere Javascript, um diesen Inhalt zu sehen
                        </iframe>
                    </div>
                } else {
                    return <p className={className} {...props}>{children}</p>
                }
            }
        }

        return <p className={className} {...props}>{children}</p>
    }
}

function extractYoutubeId (link) {
    var regex = new RegExp(`(?:https?:)?(?:\\/\\/)?(?:[0-9A-Z-]+\\.)?(?:youtu\\.be\\/|youtube(?:-nocookie)?\\.com\\S*?[^\\w\\s-])([\\w-]{11})(?=[^\\w-]|$)(?![?=&+%\\w.-]*(?:['"][^<>]*>|<\\/a>))[?=&+%\\w.-]*`);
    var match = link.match(regex);
    return { result: match, id: match && match.length > 0 ? match[1] : null };
}

export default components;